import React, {useState, useEffect, useContext}  from 'react';
import { Link, useNavigate, useLocation, Routes, Route } from 'react-router-dom'; // Importa Routes y Route
import { AuthContext } from '../contexts/AuthContext';
import Recintos from './Recintos';
import Proveedores from './Proveedores';
import Escaneos from './Escaneos';
import { ReactComponent as ClubticketsIcon } from '../Clubtickets.svg';
import { apiFetch } from '../utils/apiFetch';
import { Outlet } from 'react-router-dom';
interface MainPageProps 
{
  onLogout: () => void;
}

const MainPage: React.FC<MainPageProps> = ({ onLogout }) => 
{
  const SEGUNDOS_ENTRE_LLAMADAS_A_PROCESAR_NORMAL = 20;
  const SEGUNDOS_ENTRE_LLAMADAS_A_PROCESAR_CON_CARGA = 5;

  const {username, token} = useContext(AuthContext);  // Usa el contexto para obtener el username y el token
  const navigate = useNavigate();
  const location = useLocation();
  const [batchData, setBatchData] = useState<string | null>(null); // Maneja los mensajes del batch
  const [intervalTime, setIntervalTime] = useState<number>(SEGUNDOS_ENTRE_LLAMADAS_A_PROCESAR_NORMAL);

  //-----------------------------------------------------------

  const handleLogout = () => 
  {
    onLogout();
    navigate('/'); // Redirige a la página de login
  };

  //-----------------------------------------------------------

  // Determina la clase activa basado en la ruta actual
  const getActiveClass = (path: string) =>
  {
    return location.pathname.startsWith(path) ? 'active' : '';
  };

  //-----------------------------------------------------------

  useEffect(() => 
  {
    if (location.pathname === '/main') 
      navigate('/main/recintos');
  }, [location, navigate]);

  //-----------------------------------------------------------

  useEffect(() => 
  {
    const fetchBatchData = async () => 
    {
      try 
      {
        const response = await apiFetch(`batch/process`, 
          {headers: {
          'X-AUTH-TOKEN': token || ''}});

        if (response.status === 401)
        {
          navigate('/');
          return;
        }

        if (response.ok) 
        {
          const data = await response.json();
          if (data['error'])
          {
            setBatchData(data['error']);
            setIntervalTime(SEGUNDOS_ENTRE_LLAMADAS_A_PROCESAR_NORMAL);
          }
          else
          {
            if (data['pending'] !== 0)
            {
              if (data['pending'] === 1)
                setBatchData('1 paquete pendiente');
              else
                setBatchData(data['pending'] + ' paquetes pendientes'); // Actualiza el estado con los datos recibidos
              
              if (intervalTime !== SEGUNDOS_ENTRE_LLAMADAS_A_PROCESAR_CON_CARGA)
                setIntervalTime(SEGUNDOS_ENTRE_LLAMADAS_A_PROCESAR_CON_CARGA);
            }
            else
            {
              if (data['processed'] === true)
              {
                setBatchData("Ya está todo cargado :)");              
              }
              else
              {
                if (intervalTime !== SEGUNDOS_ENTRE_LLAMADAS_A_PROCESAR_NORMAL)                
                  setIntervalTime(SEGUNDOS_ENTRE_LLAMADAS_A_PROCESAR_NORMAL);                
                else
                  setBatchData(null); 
              }       
            }
          }
        }
        else
        {                  
          throw new Error('Error con el batch');
        }
      } 
      catch (error) 
      {
        const error_msg = error instanceof Error ? error.message : 'Error desconocido';
        setBatchData(error_msg); 
        setIntervalTime(SEGUNDOS_ENTRE_LLAMADAS_A_PROCESAR_NORMAL); 
      }
    };

    fetchBatchData(); // Llama a la función inmediatamente al montar el componente

    const intervalId = setInterval(fetchBatchData, intervalTime * 1000);
    return () => clearInterval(intervalId); // Limpia el intervalo al desmontar el componente
  }, [intervalTime, token, navigate]);

  //-----------------------------------------------------------

  return (
    <div className="main-container">
      <header className="main-header">
        <div className="container">
          <div className="greeting">
            <ClubticketsIcon className="logo-header" />
            {batchData && <p className="error-message-header">{batchData}</p>}
          </div>
          <nav>
            <ul className="nav-list">
              <li><Link to="/main/recintos" className={getActiveClass('/main/recintos')}>Recintos</Link></li>
              <li><Link to="/main/proveedores" className={getActiveClass('/main/proveedores')}>Proveedores</Link></li>
              <li><Link to="/main/escaneos" className={getActiveClass('/main/escaneos')}>Escaneos</Link></li>
              <div className="right-items">
              
                <li className="nav-item">Bienvenido, {username}</li>
                <li className="nav-item">
                  <i className="fas fa-sign-in-alt logout-icon" onClick={handleLogout}></i>
                </li>
              </div>
            </ul>
          </nav>
        </div>
      </header>      
      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
};

export default MainPage;
